<template>
  <v-row no-gutters>
    <v-col
      md="8"
      offset-md="2">
      <v-container class="page page--form">
        <ValidationObserver
          ref="obs"
          v-slot="{ valid, handleSubmit }">
          <v-form
            v-model="valid"
            @submit.prevent="handleSubmit(onSubmit)">
            <validation-input
              v-model="plan.name"
              rules="required|min:3|max:255"
              label="Nom*" />
            <validation-select
              v-model="plan.account_type"
              :items="accountTypes"
              item-text="text"
              item-value="value"
              required
              label="Compte *"
              rules="required" />
            <v-checkbox
              v-model="plan.available"
              label="Abonnement Disponible" />
            <v-checkbox
              v-model="plan.free_plan"
              label="Abonnement Gratuit (invité)" />
            <v-checkbox
              v-model="plan.can_add_users"
              label="Peut créer des utilisateurs" />
            <v-checkbox
              v-model="plan.calendar_enabled"
              label="Calendrier actif" />
            <v-checkbox
              v-model="plan.adv_enabled"
              label="ADV actif" />
            <v-btn
              type="submit"
              color="success"
              class="mr-4">
              Valider
            </v-btn>
          </v-form>
        </ValidationObserver>
      </v-container>
    </v-col>
  </v-row>
</template>

<script>
  import RESOURCES from '@batimentb/vadimm-js-api/resources'

  export default {
    name: 'NewPlan',
    data () {
      return {
        accountTypes: [
          {
            'value': 'promoteur',
            'text': 'Promoteur'
          },
          {
            'value': 'commercial',
            'text': 'CGP/Distributeur'
          }
        ],
        plan: {
          name: null,
          account_type: 'promoteur',
          calendar_enabled: false,
          adv_enabled: false,
          available: false,
          plan_cost_by_month: 50,
          lot_cost_by_month: 30,
          user_cost_by_month: 30,
          program_website_cost_by_month: 500,
          free_program_website: 0,
          free_plan: false
        }
      }
    },
    methods: {
      async onSubmit () {
        const payload = Object.assign({}, this.plan)
        try {
          await this.$api.post(RESOURCES.PLAN, payload)
          this.$awn.success('Abonnement créé')
          await this.$router.replace({ name: 'plans' })
        } catch (e) {
          this.$awn.error('Erreur lors de la création')
        }
      }
    }
  }
</script>

<style scoped>

</style>
